module.exports = __webpack_public_path__ + "img/utensils.03189694.svg";